<template>
  <div>
    <!-- <custom-header title="部门与员工" > -->
      <!-- 使用具名插槽 -->
      <!-- <template slot="right">

      </template> -->
    <!-- </custom-header> -->
    <Breadcrumb></Breadcrumb>
    <ak-model-filter-card model="storePointsDetail" @search="search" @reset="reset"/>
    <ak-model-card model="storePointsDetail" :filters="filters" :page.sync="page" :perPage="20"  tableSize="small" title="积分列表" ref="management" />

  </div>
</template>
<script>
import Breadcrumb from '../../components/tools/Breadcrumb.vue'
export default {
  components: {
    Breadcrumb
  },
  data () {
    return {
      filters: {
        store: {
          $inQuery: {
            where: {
              isDelete: false
            },
            className: 'store'
          }
        }
      },
      page: 1
    }
  },
  methods: {
    search (filter) {
      this.filters = { ...this.filters, ...filter }
      this.page = 1
    },
    reset () {
      this.page = 1
      this.filters = {
        store: {
          $inQuery: {
            where: {
              isDelete: false
            },
            className: 'store'
          }
        }
      }
    }
  }
}
</script>
